import * as z from "zod";

export const ShopperAgentReplyConfigSchema = z.object({
  enabled: z.boolean().optional(),
});

export type ShopperAgentReplyConfig = z.infer<
  typeof ShopperAgentReplyConfigSchema
>;
